import LegalDocument from './legal/LegalDocument'
import terms from './legal/content/ovacsTerms'

/**
 * Public Terms & Conditions, rendered as HTML so Google's OAuth verifier
 * and Stripe's reviewers can read it. Keep this URL stable.
 *
 * URL: https://ovacs.com/terms
 */
const TermsPage = () => (
  <LegalDocument
    doc={terms}
    description="OVACS Terms and Conditions: the agreement between you and Stirring Apps FZE LLC for using OVACS."
  />
)

export default TermsPage
